export default function (labelHtml: string, link: string) {
    // & are converted to &amp; in the HTML so our comparison below would fail
    const labelHtmlWithoutEntities = labelHtml.replace(/&amp;/g, '&');

    // Label will be considered same as link if it starts with the link and optionally has one more character at the end
    // This is to accommodate the ending slash to a root domain being added by TextFormatter in the URL attribute but not the label
    // TODO: this might need improvement to support protocol-less URLs if that feature is enabled in TextFormatter
    return link.indexOf(labelHtmlWithoutEntities) === 0 && (labelHtmlWithoutEntities.length === link.length || labelHtmlWithoutEntities.length + 1 === link.length);
}
